module.exports = xadminUi;